import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MediaPickerDialogComponent } from '../../media-picker-dialog/media-picker-dialog.component';
import { EstablishmentService } from '../../../services/establishment/establishment.service';
import { ToastService } from '../../../services/toast/toast.service';
import { LoaderComponent } from '../../../atoms/loader/loader.component';

// add or edit a utsav. data.utsav = row when editing (null when adding). self-saving.
@Component({
  selector: 'app-utsav-form-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, LoaderComponent],
  templateUrl: './utsav-form-dialog.component.html',
  styleUrls: ['./utsav-form-dialog.component.scss', '../../../../common-style/ac-dialog.scss'],
})
export class UtsavFormDialogComponent implements OnInit {
  form: FormGroup;
  isEdit: boolean = false;
  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<UtsavFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { utsav: any | null },
    private establishmentService: EstablishmentService,
    private toastService: ToastService,
    private dialog: MatDialog
  ) {
    this.form = this.fb.group({
      name: ['', Validators.required],
      utsavCode: [''],
      previewImgUrl: [''],
      utsavStartDate: [''],
      utsavEndDate: [''],
      accommodationStartDate: [''],
      accommodationEndDate: [''],
      bookingStartDate: [''],
      bookingEndDate: [''],
      locationUrl: [''],
    });
  }

  ngOnInit(): void {
    if (this.data?.utsav) {
      this.isEdit = true;
      const u = this.data.utsav;
      this.form.patchValue({
        name: u.name || '',
        utsavCode: u.utsavCode || '',
        previewImgUrl: u.previewImgUrl || '',
        utsavStartDate: u.utsavStartDate || '',
        utsavEndDate: u.utsavEndDate || '',
        accommodationStartDate: u.accommodationStartDate || '',
        accommodationEndDate: u.accommodationEndDate || '',
        bookingStartDate: u.bookingStartDate || '',
        bookingEndDate: u.bookingEndDate || '',
        locationUrl: u.locationUrl || '',
      });
    }
  }

  // pick the preview image from the media library (central + this branch's media)
  pickImage(): void {
    const activeEst = localStorage.getItem('activeEstablishmentId');
    const ref = this.dialog.open(MediaPickerDialogComponent, {
      width: '760px',
      maxWidth: 'calc(100vw - 32px)',
      maxHeight: 'calc(100dvh - 32px)',
      data: {
        establishmentId: activeEst ? Number(activeEst) : null,
        category: 'UTSAV',
        selectedUrl: this.form.get('previewImgUrl')?.value || '',
      },
    });
    ref.afterClosed().subscribe((url: string | undefined) => {
      if (url) this.form.patchValue({ previewImgUrl: url });
    });
  }

  clearImage(): void {
    this.form.patchValue({ previewImgUrl: '' });
  }

  submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.toastService.error('Utsav name is required.');
      return;
    }
    this.isLoading = true;
    const payload: any = { ...this.form.value };
    let request$;
    if (this.isEdit) {
      request$ = this.establishmentService.updateUtsav(this.data.utsav.utsavId, payload);
    } else {
      const activeEst = localStorage.getItem('activeEstablishmentId');
      payload.establishmentId = activeEst ? Number(activeEst) : null;
      request$ = this.establishmentService.addUtsav(payload);
    }

    request$.subscribe({
      next: (res: any) => {
        this.toastService.success(res?.message || 'Utsav saved.');
        this.isLoading = false;
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to save utsav.');
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
